import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["businessTitle", "businessTitleHiddenText", "level", "departmentName", "departmentId", "departmentHiddenText", "city", "country", "locationHiddenText", "size", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe } from '@amzn/stencil-react-desc';
import Avatar from "./Avatar";
import AvatarText from "./AvatarText";
import { layoutConstants, PersonalDetailsAvatarDefaultProps as defaultProps } from "./avatarConstants";
import { formatBusinessTitle, formatDepartment, formatLocation } from "./formatters";
import { describedPersonalDetails } from "./personalDetails";
import { jsx as ___EmotionJSX } from "@emotion/core";

var PersonalDetailsAvatar = function PersonalDetailsAvatar(_ref) {
  var businessTitle = _ref.businessTitle,
      _ref$businessTitleHid = _ref.businessTitleHiddenText,
      businessTitleHiddenText = _ref$businessTitleHid === void 0 ? defaultProps.businessTitleHiddenText : _ref$businessTitleHid,
      level = _ref.level,
      departmentName = _ref.departmentName,
      departmentId = _ref.departmentId,
      _ref$departmentHidden = _ref.departmentHiddenText,
      departmentHiddenText = _ref$departmentHidden === void 0 ? defaultProps.departmentHiddenText : _ref$departmentHidden,
      city = _ref.city,
      country = _ref.country,
      _ref$locationHiddenTe = _ref.locationHiddenText,
      locationHiddenText = _ref$locationHiddenTe === void 0 ? defaultProps.locationHiddenText : _ref$locationHiddenTe,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? defaultProps.size : _ref$size,
      children = _ref.children,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  var maxChildren = layoutConstants[size].maxChildren;
  var renderedChildren = React.Children.toArray(children).slice(0, maxChildren);
  var availableTextLines = maxChildren - renderedChildren.length;
  var businessTitleAndLevel = {
    text: formatBusinessTitle({
      businessTitle: businessTitle,
      level: level
    }),
    hiddenText: businessTitleHiddenText
  };
  var location = {
    text: formatLocation({
      city: city,
      country: country
    }),
    hiddenText: locationHiddenText
  };
  var department = {
    text: formatDepartment({
      departmentName: departmentName,
      departmentId: departmentId
    }),
    hiddenText: departmentHiddenText
  };
  var renderedTextLines = [businessTitleAndLevel, availableTextLines > 2 ? department : location, availableTextLines > 2 ? location : department].filter(function (entry) {
    return !!entry.text;
  }).slice(0, availableTextLines);
  return ___EmotionJSX(Avatar, _extends({
    size: size
  }, forwardedProps), renderedTextLines.map(function (entry, index) {
    return ___EmotionJSX(AvatarText, {
      hiddenText: entry.hiddenText,
      key: index
    }, entry.text);
  }), renderedChildren);
};

PersonalDetailsAvatar.displayName = 'PersonalDetailsAvatar';
PersonalDetailsAvatar.defaultProps = {
  size: defaultProps.size
};
var PersonalDetailsAvatarWithDocs = describe(PersonalDetailsAvatar).description('Used to display an Avatar with some additional info like business title, job level etc.');
PersonalDetailsAvatarWithDocs.propTypes = _objectSpread(_objectSpread({}, Avatar.describedPropTypes), describedPersonalDetails);
export default PersonalDetailsAvatarWithDocs;